// extracted by mini-css-extract-plugin
module.exports = {"dressCodeCtaWrapper":"dressCodeCtaWrapper--ce73b"};